import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormGroup } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { ControlLabel } from 'react-bootstrap';
import { HelpBlock } from 'react-bootstrap';
import { Alert, Row, Col } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'

import Logo from '../statics/images/logo_default.png'

import '../statics/css/register.css';
import '../statics/css/util.css';

import moment from 'moment'

import { registerUser, checkCodeProfessor, checkExistsRequest } from '../dao-firebase/daofirebase';

import Loader from 'react-loader-advanced';

const DAY_FORMAT = 'DD/MM/YYYY'

class RegisterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form_name: '',
      form_last_name: '',
      form_gender: 'male',
      form_born_date: '',
      form_service: 'consult', //alterar -> 'consult' para lucas e ary
      form_email: '',
      form_phone: '',
      aux_old_size_phone: 0,
      form_professor_code: '',

      message: '',
      messageStatus: '',
      selectedDay: '',

      load: false,
    }

    this.goToLogin = this.goToLogin.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
  }

  componentWillMount() {

    //this.verifyUser();
  }

  verifyUser() {
    if (JSON.parse(localStorage.getItem("USER")) == undefined || JSON.parse(localStorage.getItem("USER")) == null) {

      this.props.history.push('/login')

    } else {

      switch (JSON.parse(localStorage.getItem("USER")).role) {

        case 'student':

          this.setState({
            user_role: 'student',
          })

          this.props.history.push('/aluno_detail')
          break;


        case 'professor':
          this.setState({
            user_role: 'professor',
          })

          this.props.history.push('/alunos')

          break;
      }

      console.log("USER LOGADO: " + localStorage.getItem("USER"));
    }

    this.setState({
      loaded: false,
    })
  }

  getValidationState() {
    const length = this.state.form_email.length;
    if (length > 0 && !this.validateEmail(this.state.form_email)) {
      return 'warning';
    } else if (length > 0 && this.validateEmail(this.state.form_email)) {
      return 'success';
    }
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
    return null;
  }

  getValidationStatePhone() {
    const length = this.state.form_phone.length;
    //console.log("this.state.born_date: " + this.state.form_born_date)
    if (this.isValidPhone(this.state.form_phone)) {
      return 'success';
    } else if (length > 0 && !this.isValidDate(this.state.form_phone)) {
      return 'warning';
    }

    return null;
  }

  getValidationStateBornDate() {
    const length = this.state.form_born_date.length;
    //console.log("this.state.born_date: " + this.state.form_born_date)
    if (this.isValidDate(this.state.form_born_date)) {
      console.log("Entrou aqui")
      return 'success';
    } else if (length == 10 && !this.isValidDate(this.state.form_born_date)) {
      return 'error';
    } else if (length > 0 && !this.isValidDate(this.state.form_born_date)) {
      return 'warning';
    }
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
    return null;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  handleDayChange(day) {
    this.setState({
      selectedDay: day
    });
  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onInputPhoneMaskChange(target) {

    let value = target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/\//g, "");
    value = value.replace(/ /g, "");

    console.log(value + " - Length: " + value.length);
    console.log("old size: " + this.state.aux_old_size_phone)

    let old_size = value.length;

    if ((value.length == 1 && this.state.aux_old_size_phone == 1) || (value.length == 1 && this.state.aux_old_size_phone == 2)) {
      value = "";
      old_size = 0;
    } else if (value.length == 1 || (value.length == 2 && this.state.aux_old_size_phone == 2)) {
      let aux = value;
      value = "(";
      value += aux.substring(0, 1);
      value += " )";
    } else if (value.length == 2) {
      let aux = value;
      value = "(";
      value += aux;
      value += ")";
    } else if (value.length >= 3 && value.length <= 6) {
      let aux = value;
      value = "(";
      value += aux.substring(0, 2);
      value += ")";
      value += " ";
      value += aux.substring(2);
    } else if (value.length >= 7 && value.length <= 10) {
      let aux = value;
      value = "(";
      value += aux.substring(0, 2);
      value += ")";
      value += " ";
      value += aux.substring(2, 6);
      value += "-";
      value += aux.substring(6);
    } else if (value.length > 10) {
      let aux = value;
      value = "(";
      value += aux.substring(0, 2);
      value += ")";
      value += " ";
      value += aux.substring(2, 3);
      value += " ";
      value += aux.substring(3, 7);
      value += "-";
      value += aux.substring(7, 11);
    }

    this.state.aux_old_size_phone = old_size;

    //console.log("IS VALID DATE: " + this.isValidDate(value))

    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onInputDateMaskChange(target) {

    let value = target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/\//g, "");

    //console.log(value + " - Length: " + value.length);

    if (value.length >= 3 && value.length < 5) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2);
    } else if (value.length >= 5) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2, 4);
      value += "/";
      value += aux.substring(4);
    } else if (value.length >= 8) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2, 4);
      value += "/";
      value += aux.substring(4, 8);
    }

    //console.log("VALUE: " + value);
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    console.log("IS VALID DATE: " + this.isValidDate(value))

    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  isValidPhone(value) {
    value = value.replace(/\D/g, "");
    value = value.replace(/\//g, "");
    value = value.replace(/ /g, "");

    if (value.length >= 10) {
      return true;
    } else {
      return false;
    }
  }

  isValidDate(dateString) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  };

  closeMessage() {
    this.setState({ message: '' });
  }

  goToLogin() {
    this.props.history.push('/login');
  }

  onChangeGender(event) {
    console.log(event.target.value)
    this.setState({
      form_gender: event.target.value
    })
  }

  onChangeService(event) {
    console.log(event.target.value)
    this.setState({
      form_service: event.target.value
    })
  }

  renderMessage(message) {

    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  registerNewUser() {

    this.setState({
      load: true,
    })

    if (this.validateEmail(this.state.form_email)
      && this.isValidDate(this.state.form_born_date)
      && this.state.form_name.length > 0
      && this.isValidPhone(this.state.form_phone)
      && this.state.form_last_name.length > 0) {

      //Montando usuário
      //Setar código do professor aqui

      //DEV
      //this.state.form_professor_code = "OXfYwE44mAd8khob1VdCUfChSij2";
      //this.state.form_professor_code = "ykXzEm6fyOaoDp9Pp2LIK3ritmP2";

      //LUCAS
      //this.state.form_professor_code = "EHlEz8CY9dOC0W0UQ3EfBXsISM32";

      //ARY
      this.state.form_professor_code = "DhQY9F5ValNBZ0LWIIrVfWfhteE3";

      //FamilyFit
      //this.state.form_professor_code = "5pG5iejhjtfub6Amp92byq6Cfxv2";

      let user = {
        name: this.state.form_name,
        last_name: this.state.form_last_name,
        gender: this.state.form_gender,
        born_date: this.state.form_born_date,
        service: this.state.form_service,
        email: this.state.form_email,
        phone: this.state.form_phone,
        professor_code: this.state.form_professor_code,
        role: "student",
        status: 'WAIT_ACCEPT',
      }

      checkCodeProfessor(this.state.form_professor_code, (success) => {

        if (success) {

          checkExistsRequest(this.state.form_professor_code, this.state.form_email, (success, response_message) => {

            if (success) {
              registerUser(user, (response, success) => {
                if (success) {
                  this.setState({
                    //limpando form
                    form_name: '',
                    form_last_name: '',
                    form_gender: 'male',
                    form_born_date: '',
                    form_service: 'personal',
                    form_email: '',
                    form_phone: '',
                    form_professor_code: '',

                    message: 'Pedido enviado com sucesso, aguarde aprovação do professor!',
                    messageStatus: 'success',
                    load: false,
                  })
                } else {
                  this.setState({
                    message: response.message,
                    messageStatus: 'danger',
                    load: false,
                  })
                }
              })
            } else {

              this.setState({
                message: response_message,
                load: false,
              })

            }

          })

        } else {

          this.setState({
            message: "Código do professor inválido!",
            load: false,
          })

        }
      })



    } else {

      let messageInvalid = 'Existem campos inválidos!';

      if (this.state.form_name.length == 0) {
        messageInvalid += " Insira um nome."
      }

      if (this.state.form_last_name.length == 0) {
        messageInvalid += " Insira um sobrenome."
      }


      if (this.state.form_email == "") {
        messageInvalid += " Insira um email."
      } else if (!this.validateEmail(this.state.form_email)) {
        messageInvalid += " Insira um email válido."
      }

      if (!this.isValidDate(this.state.form_born_date)) {
        messageInvalid += " Insira uma data de nascimento válida."
      }

      if (!this.isValidPhone(this.state.form_phone)) {
        messageInvalid += " Insira um telefone válido."
      }

      this.setState({
        message: messageInvalid,
        load: false,
      });
    }


  }

  render() {

    const { selectedDay } = this.state;
    const formattedDay = this.state.selectedDay
      ? moment(this.state.selectedDay).format(DAY_FORMAT)
      : ''

    return (
      <div className="register-page">

        <Loader show={this.state.load} message={<div className="loader"></div>}
          backgroundStyle={{ backgroundColor: 'none' }}
          foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

          <div className="form">
            <h1>Registrar</h1>
            <form className="form-login" onSubmit={(event) => this.onHandleSubmit(event)}>
              {this.state.message != '' ?
                <Alert bsStyle={this.state.messageStatus == '' ? 'warning' : this.state.messageStatus}>
                  {this.renderMessage(this.state.message)}
                </Alert>
                : null}

              <FormGroup controlId="formControlsName">
                <ControlLabel>Nome</ControlLabel>
                <FormControl
                  name="form_name"
                  type="text"
                  value={this.state.form_name}
                  placeholder="Insira seu nome"
                  onChange={(event) => this.onInputChange(event.target)} />
              </FormGroup>

              <FormGroup controlId="formControlsName">
                <ControlLabel>Sobrenome</ControlLabel>
                <FormControl
                  name="form_last_name"
                  type="text"
                  value={this.state.form_last_name}
                  placeholder="Insira seu sobrenome"
                  onChange={(event) => this.onInputChange(event.target)} />
              </FormGroup>

              <Row className="show-grid">
                <Col xs={6} md={6}>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Gênero</ControlLabel>
                    <FormControl componentClass="select" placeholder="Selecione" onChange={(event) => this.onChangeGender(event)}>
                      <option value="male">Masculino</option>
                      <option value="female">Feminino</option>
                      <option value="other">Outro</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col xs={6} md={6} className="no-p-left">
                  <FormGroup controlId="formControlsBornDate"
                    validationState={this.getValidationStateBornDate()}>
                    <ControlLabel>Nascimento</ControlLabel>
                    <FormControl
                      name="form_born_date"
                      type="text"
                      value={this.state.form_born_date}
                      placeholder="DD/MM/YYYY"
                      onChange={(event) => this.onInputDateMaskChange(event.target)} />
                  </FormGroup>
                </Col>
              </Row>

              {/* <FormGroup controlId="formControlsSelect">
                <ControlLabel>Código do professor</ControlLabel>
                <FormControl
                  name="form_professor_code"
                  type="text"
                  value={this.state.form_professor_code}
                  placeholder="Insira um código"
                  onChange={(event) => this.onInputChange(event.target)}
                />
              </FormGroup> */}

              <FormGroup controlId="formControlsSelect">
                <ControlLabel>Serviço</ControlLabel>
                <FormControl componentClass="select" placeholder="Selecione" onChange={(event) => this.onChangeService(event)}>
                  {/* <option value="personal">Musculação</option> */}
                  <option value="consult">Consultoria esportiva</option>
                  <option value="personal">Personal trainer</option>
                </FormControl>
              </FormGroup>

              {/* validationState={this.getValidationStatePhone()}> */}
              <FormGroup
                controlId="formBasicText">
                <ControlLabel>Telefone</ControlLabel>
                <FormControl
                  className="phone-input"
                  name="form_phone"
                  type="text"
                  value={this.state.form_phone}
                  placeholder="Insira um telefone"
                  onChange={(event) => this.onInputPhoneMaskChange(event.target)}
                />

              </FormGroup>

              <FormGroup
                controlId="formBasicText"
                validationState={this.getValidationState()}>
                <ControlLabel>Email</ControlLabel>
                <FormControl
                  className="email-input"
                  name="form_email"
                  type="text"
                  value={this.state.form_email}
                  placeholder="Insira um email"
                  onChange={(event) => this.onInputChange(event.target)}
                />

              </FormGroup>

              <Button className="register-button" onClick={() => this.registerNewUser()}> Cadastrar</Button>
              <div className="form-register" onClick={() => this.goToLogin()}>
                <HelpBlock>Já possui uma conta?</HelpBlock>
                <strong>Retornar para login</strong>
              </div>
            </form>

          </div>
        </Loader>

      </div >
    );
  }
}

export default RegisterForm;


// WEBPACK FOOTER //
// src/components/register-form.js